import React, { useMemo } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Button, Dropdown } from 'antd-v5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CheckCircleOutlined, LoadingOutlined, ShoppingOutlined } from '@ant-design/icons';
import './styles.css';
import { COLLECTION_API_URL } from '../../../../../../../constants';

const CollectionProductsListHeader = props => {
  const {
    selectedProducts,
    selectedCollection,
    showAddProduct,
    saveButtonProps,
    clientId,
    openRenameModal,
    openDeleteModal,
    openShareModal,
    handleOpenProductPage,
    vendors,
    openAttachmentUploadModal,
    isFetchingVendors,
  } = props;

  const flags = useFlags();
  const title = useMemo(() => {
    if (!showAddProduct) {
      return selectedCollection.name;
    }

    if (!selectedProducts.size) {
      return 'Add Products';
    }

    return `${selectedProducts.size} selected`;
  }, [showAddProduct, selectedCollection.name, selectedProducts]);

  const handleAttachment = event => {
    const files = Array.from(event.target.files);
    // Handle the attachment logic here
  };

  const dropdownOptions = useMemo(
    () => [
      {
        key: '1',
        label: (
          <a
            target="_blank"
            href={`${COLLECTION_API_URL}/${clientId}/${selectedCollection.id}`}
            rel="noreferrer"
          >
            View on Web
          </a>
        ),
        icon: <FontAwesomeIcon icon="fa-regular fa-browser" style={{ fontSize: '16px' }} />,
      },
      {
        key: '2',
        label: 'Rename',
        icon: <FontAwesomeIcon icon="fa-light fa-pen" style={{ fontSize: '16px' }} />,
        onClick: () => openRenameModal(),
      },
      {
        key: '3',
        label: 'Delete',
        icon: <FontAwesomeIcon icon="fa-regular fa-trash-can" style={{ fontSize: '16px' }} />,
        onClick: () => openDeleteModal(),
      },
    ],
    [clientId, selectedCollection],
  );

  const productItems = useMemo(() => {
    const vendorItems =
      vendors?.length > 0
        ? [
          {
            key: 'brands',
            type: 'group',
            label: 'Brands',
            children: vendors?.map(brand => ({
              key: brand.id,
              label: brand.name,
              onClick: () => handleOpenProductPage(`brands-${brand.id}`),
            })),
          },
        ]
        : [];

    return [
      {
        key: 'product',
        type: 'group',
        label: 'Inventory',
        children: [
          {
            key: 'product-all',
            label: 'All Products',
            icon: <ShoppingOutlined />,
            onClick: () => handleOpenProductPage('product-all'),
          },
          {
            key: 'product-in-stock',
            label: 'In Stock',
            icon: <CheckCircleOutlined />,
            onClick: () => handleOpenProductPage('product-in-stock'),
          },
        ],
      },
      ...vendorItems,
    ];
  }, [vendors]);

  return (
    <div className="clients-v2-collection-details--header">
      <div className="clients-v2-collection-details--header-info">
        <span className="clients-v2-collection-details--header-title">{title}</span>

        {!showAddProduct && (
          <span className="clients-v2-collection-details--header-shared">
            {selectedCollection.isShared ? 'Shared With Client' : 'Not Shared'}
          </span>
        )}
      </div>

      <div className="clients-v2-collection-details--header-options">
        {showAddProduct ? (
          <Button type="link" className="cb-link-btn-action" {...saveButtonProps}>
            Save
          </Button>
        ) : (
          <>
            <Dropdown
              trigger={['click']}
              arrow
              menu={{
                style: {
                  width: '200px',
                },
                items: productItems,
              }}
            >
              <Button type="link" className="cb-link-btn-action" icon={<FontAwesomeIcon icon="fa-regular fa-folder-plus" />}>
                Add products
              </Button>
            </Dropdown>
            {flags.files && (
              <Button
                type="link"
                className="cb-link-btn-action"
                icon={<FontAwesomeIcon icon="fa-regular fa-paperclip" />}
                onClick={() => openAttachmentUploadModal()}
              >
                Attach Media
              </Button>
            )}
            <Button type="link" className="cb-link-btn-action" icon={<FontAwesomeIcon icon="fa-regular fa-share" />} onClick={openShareModal}>
              Share
            </Button>
            <Dropdown menu={{ items: dropdownOptions }}>
              <Button type="link" className="cb-link-btn-action" icon={<FontAwesomeIcon icon="fa-solid fa-ellipsis-vertical" />} />
            </Dropdown>
          </>
        )}
      </div>
    </div>
  );
};

export default CollectionProductsListHeader;
